// import React from 'react'
import { Route } from 'react-router-dom'

import { SalesCost,SalesCostAccess } from "../pages/report/sales-cost";


export const ReportRouter = (<>

  <Route path="/report/sales-cost/" exact element={<SalesCost />}>
      <Route index element={<SalesCostAccess />} />
    </Route>
</>)